import { mapDispatchButtonGroup } from 'reg_redesign/redux/connectFunctions';
import BasicInput from '@opploans/basic-input-component/BasicInput';
import ButtonGroup from '@opploans/button-group-component/ButtonGroup';
import configureProgressBar from 'reg_redesign/config/configureProgressBar';
import configureTitle from 'reg_redesign/config/configureTitle';
import nextButtonConfig from 'reg_redesign/config/nextButtonConfig';

export default {
  defaultNextPage: 'page-7.2',
  content: [
    configureProgressBar(32),
    configureTitle('Who is your employer?'),
    {
      component: BasicInput,
      props: {
        id: 'nameOfIncome',
        name: 'nameOfIncomeSearch',
        label: 'Name of Employer',
        type: 'text',
        maxLength: 200,
        formControlStyle: {
          marginBottom: '1.5rem'
        },
        autoComplete: 'new-password'
      }
    },
    {
      component: BasicInput,
      props: {
        id: 'occupation',
        label: 'Occupation',
        type: 'text',
        formControlStyle: {
          marginBottom: '1.5rem'
        }
      }
    },
    configureTitle('Do you still currently work for this employer?'),
    {
      component: ButtonGroup,
      dispatchOverride: mapDispatchButtonGroup,
      props: {
        id: 'employmentStatus',
        options: [
          {
            displayValue: 'Yes',
            id: 'employmentStatusYes',
            value: 'Yes'
          },
          {
            displayValue: 'No',
            id: 'employmentStatusNo',
            value: 'No'
          }
        ]
      }
    },
    nextButtonConfig('page-7.1')
  ]
};
